export enum Language {
  ALL = 'ALL',
  ENGLISH = 'en',
  JAPANESE = 'jp',
}

export enum ASSETS {
  DRILLS = 'drills',
  COACH = 'plan',
  SHOP = 'shop',
  HOME = 'home',
  FITTING = 'fittings',
  PLAY = 'play',
}
